import { render } from "./Backend.vue?vue&type=template&id=52802944&scoped=true"
import script from "./Backend.vue?vue&type=script&lang=js"
export * from "./Backend.vue?vue&type=script&lang=js"

import "./Backend.vue?vue&type=style&index=0&id=52802944&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-52802944"

export default script